module.exports = __webpack_public_path__ + "static/media/quote-buddha-mouth.fa431d66.png";